export const CREATE_ACCOUNT = 'CREATE_ACCOUNT';
export const ERROR_MESSAGE = 'ERROR_MESSAGE';
export const RESET_PASSWORD_ERROR_MESSAGE = 'RESET_PASSWORD_ERROR_MESSAGE';
